<script setup>
import { computed, getCurrentInstance } from 'vue';

const { proxy } = getCurrentInstance();
const store = proxy.$store;
const route = proxy.$route;
const router = proxy.$router;

// --- Computed ---

const tableName = computed(() => route.params.component);

const component = computed(() => {
    return store.state.components.items.find(o => o.tableName === tableName.value);
});

const isForm = computed(() => component.value?.navigationGroup === 'Forms');

const label = computed(() => isForm.value ? 'form' : 'content type');

// --- Methods ---

const deleteForm = () => {
    store.dispatch('modals/show', {
        componentName: 'ConfirmModal',
        obj: {
            modalTitle: 'Are you absolutely sure?',
            modalBody: `
                <div class="alert alert-danger">
                    <strong>This action will result in loss of data.</strong>
                </div>
                <p>
                    This action <strong>cannot</strong> be undone. This will permanently delete the ${label.value}
                    <strong>${component.value.title}</strong> and all of its data.
                </p>
            `,
            confirmStr: component.value.title,
            onConfirm: () => {
                store.dispatch('itemData/delete', {
                        tableName: 'modulecomponents',
                        id: component.value.id
                    })
                    .finally(() => {
                        router.push({ name: 'dashboard' });
                    });
            }
        }
    });
};
</script>

<template>
    <div class="root">
        <div>
            <h5 class="list-group-item-heading">Delete this {{ label }}</h5>

            <p class="mb-0">
                Once you delete a {{ label }}, all data is deleted and there is no going back. Please
                be certain.
            </p>
        </div>

        <button class="btn btn-danger ms-2" type="button" @click="deleteForm">
            Delete this {{ label }}
        </button>
    </div>
</template>

<style scoped>
.root {
    display: flex;
    align-items: center;
    font-size: 14px;
}

.root > :first-child {
    flex: auto;
}
</style>